export class RollRedrawObserver {

    public constructor() {
        this.observers = [];
    }

    private observers: Array<Function>;

    public addObserver(observer: Function): void {
        this.observers.push(observer);
    }

    public notifyObservers(): void {
        this.observers.forEach(observer => observer());
    }

    public dropObserver(observer: Function): void {
        this.observers = this.observers.filter(o => o !== observer);
    }
}